import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AreasRoutingModule } from './areas-routing.module';

import { ComponentesCompartidosModule } from '../componentes-compartidos/componentes-compartidos.module';

import { PaginaAreasComponent } from './pagina-areas/pagina-areas.component';
import { ListarAreasComponent } from './listar-areas/listar-areas.component';

import { AreasService } from 'src/app/servicios/areas.service';



@NgModule({
  declarations: [
    PaginaAreasComponent,
    ListarAreasComponent
  ],
  exports: [
    PaginaAreasComponent
  ],
  imports: [
    CommonModule,
    AreasRoutingModule,
    ComponentesCompartidosModule
  ],
  providers: [
    AreasService
  ]
})
export class AreasModule { }
